import React from 'react';
import { Typography, Button, ButtonProps } from '@material-ui/core';
import { FaPlusCircle, FaTimesCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface ICreateOrderButtonProps extends ButtonProps {
  height?: number | string;
  width?: number | string;
  isCreatingOrder?: boolean;
}

const CreateOrderButton: React.FC<ICreateOrderButtonProps> = ({
  width,
  height,
  isCreatingOrder,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      className={classes.container}
      startIcon={
        isCreatingOrder ? (
          <FaTimesCircle size={24} color="#7030A0" />
        ) : (
          <FaPlusCircle size={24} color="#7030A0" />
        )
      }
      style={{
        width,
        height,
      }}
      {...rest}
    >
      {isCreatingOrder ? (
        <Typography
          variant="subtitle1"
          style={{ textTransform: 'capitalize', color: '#000' }}
        >
          {t('components:buttons.selectLocation')}
        </Typography>
      ) : (
        <Typography variant="subtitle1" className={classes.title}>
          {t('components:buttons.createOrder')}
        </Typography>
      )}
    </Button>
  );
};

export default CreateOrderButton;
